import { Injectable } from '@angular/core';
import { ResourceService } from '../../../common/resource.service';
import { ConfiguracaoLogin } from './configuracao-login';
import { HttpClient } from '@angular/common/http';
import { ConfiguracaoLoginSerializer } from './configuracao-login.serializer';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ResourceAdmService } from '../../../common/resource-adm.service';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracaoLoginService extends ResourceAdmService<ConfiguracaoLogin> {

  constructor(http: HttpClient) {
    super(http, 'configuracao-login', new ConfiguracaoLoginSerializer(ConfiguracaoLogin));
  }

  getConfiguracao(idEntidade: number): Observable<ConfiguracaoLogin>{
    return this.httpClient.get<ConfiguracaoLogin>(`${this.urlEndpoint}/entidade/${idEntidade}`).pipe(
      map(data => (data) ? this.serializer.fromJson(data) as ConfiguracaoLogin: null),
      take(1)
    )
  }
}
